export default __webpack_public_path__ + "static/media/menu-konten.704ca7d0.svg";